import { LicenseInfo } from '@mui/x-license';
import React from 'react';
import ReactDOM from 'react-dom';

import { runRootSaga } from 'app/redux/configureStore';

import './styles/index.scss';

import App from './app';

window.global ??= window;

// clean up now-unused service worker
navigator.serviceWorker
  ?.getRegistration()
  .then((registration) => registration?.unregister())
  .catch(() => {});

// mui x data grid license
LicenseInfo.setLicenseKey(
  import.meta.env.REACT_APP_MUI_X_LICENSE_KEY as string
);

ReactDOM.render(<App />, document.getElementById('root'));

runRootSaga();
